import { AlertProps } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { BaseAlert } from './base';

export const WarningAlert = (props: AlertProps) => {
	return <BaseAlert icon={<IconAlertCircle />} variant="filled" bg="red.1" {...props} />;
};
